import * as Sentry from "@sentry/nextjs";
import getConfig from "next/config";

const { serverRuntimeConfig: serverConfig, publicRuntimeConfig: clientConfig } =
  getConfig();

const initSentry = (sideString) => {
  const CONFIG = sideString === "server" ? serverConfig : clientConfig;

  const sentry_dsn = CONFIG.SENTRY.dsn;
  const project = CONFIG.SENTRY.project;
  const platform = CONFIG.ENV.PLATFORM;

  Sentry.setTag("platform", platform);
  Sentry.setTag("project", project);
  Sentry.setContext("project", {
    platform,
    project,
  });

  Sentry.init({
    dsn: sentry_dsn,
    tracesSampleRate: 1.0,
    environment: platform,
  });
};

export default initSentry;
